<div (click)="togglePaddock()" class="d-flex gap-3 m-1 p-2 rounded-2 pointer pointer-hover-blue background-light-gray">
    <div class="d-flex justify-content-center">
        @if (selectableForAlteration || selectableForDeletion) {
            <div class="m-0 d-flex justify-content-center">
                <input (change)="onCheckUncheck()"
                    [checked]="selected"
                    [id]="'selectPaddock-'+ paddock.id"
                    class="form-check-input m-auto p-2"
                    type="checkbox"
                    value="">
            </div>
        }
    </div>
    <div [attr.aria-controls]="'paddockCollapse-'+paddock.id" [attr.aria-expanded]="false"
         [attr.data-bs-target]="!selected ? '#paddockCollapse-'+paddock.id : ''"
         [attr.data-bs-toggle]="{'collapse': selected, 'collapsed': open && !selected}">
         <app-paddock-svg [colored]="true" class="img-fluid img-max "></app-paddock-svg>
    </div>
    <div [attr.aria-controls]="'paddockCollapse-'+paddock.id"
         [attr.aria-expanded]="false"
         [attr.data-bs-target]="!selected ? '#paddockCollapse-'+paddock.id : ''"
         [attr.data-bs-toggle]="{'collapse': selected, 'collapsed': open && !selected}"
         class="d-flex align-items-center">
        <div class="fs-main">
            {{ paddock!.name || '-' }}
            <span data-id="count">({{ total() !== undefined ? `${animals.length}/${total()}` : animals.length }})</span>
        </div>
    </div>
</div>
<div [id]="'paddockCollapse-'+paddock.id" [ngClass]="{'collapse': !selected && !open, 'collapsed': open}">
    @if (animals.length == 0) {
        <div class="text-center p-3 opacity-50">
            No animals
        </div>
    }
    @for (animal of animals; track animal.id) {
        <div class="card mb-1 ms-1 me-1">
            <app-animal-button [id]="animal.id"
                               [clickable]="focusOnClick()"
                               [selected]="animalIsSelected(animal)"
                               [selectableForAlteration]="selectableForAlteration"
                               [selectableForDeletion]="selectableForDeletion"
                               [standalone]="false"/>
        </div>
    }
</div>
